import { IconButton, Tooltip } from "@mui/material";
import { useTranslation } from "react-i18next";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";

const HideButton = ({ label = "Hide Selected", onClick = () => {}, disabled = false }) => {
  const { t } = useTranslation();
  return (
    <Tooltip title={t(label)}>
      <span>
        <IconButton onClick={onClick} disabled={disabled} variant="Light Green">
          <VisibilityOffIcon />
        </IconButton>
      </span>
    </Tooltip>
  );
};

export default HideButton;
